
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The scheme ID of the `}<a parentName="p" {...{
        "href": "/schema/named-type/WebhookSubscription",
        "title": "A subscription for a given event type and scheme to be delivered via webhook"
      }}><inlineCode parentName="a">{`WebhookSubscription`}</inlineCode></a>{` that generated the request.`}</p>
    <p>{`This is used to determine which data source includes the `}<inlineCode parentName="p">{`requestId`}</inlineCode>{`.`}</p>
    <p>{`Currently, only `}<inlineCode parentName="p">{`seekAnz`}</inlineCode>{` and `}<inlineCode parentName="p">{`seekAnzPublicTest`}</inlineCode>{` are supported.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;